import { Component, OnDestroy, OnInit } from "@angular/core";
import { webSocket, WebSocketSubject } from "rxjs/webSocket";
import { APIService } from "../../api/api.service";
import { NotifierService } from "../../_services/notifier.service";
import * as moment from "moment";
import { environment } from "src/environments/environment";
import { ActivatedRoute } from "@angular/router";


@Component({
  selector: "app-itas",
  templateUrl: "./itas.component.html",
  styleUrls: ["./itas.component.css"],
})
export class ITASComponent implements OnInit {
  regionId = localStorage.getItem("regionId");
  accountId = localStorage.getItem("accountId");
  selectedAccountId = localStorage.getItem("selectedaccountIds");
  customerType: string = localStorage.getItem("customerType");
  emailId = localStorage.getItem("eId");
  urlPrefix: any = localStorage.getItem("role") == "Admin" ? "admin" : "client";
  private webSocketSubject: WebSocketSubject<any>;
  newMessage: string;
  messages: any[] = [];
  isDraggingFile: boolean = false;
  socket: WebSocket;
  socketOpen: boolean = false;
  optionAccountInfo: boolean = false;
  currentMessage: any;
  isAccActive = false;
  isManageActive = false;
  isSwayamActive = false;
  isBillingActive = false;
  isWafrActive = false;
  isConnectionOpen: boolean = false;
  isFirstReload: boolean = true;
  welcomeMsg: boolean = true;
  printingInProgress = false;
  aniCompleted: boolean = true;
  isQuesloading: boolean = false;
  isPresent: boolean = true;
  mId: string = "";
  initloader = true;
  firstQues=true;
  injestGenAiLoader =true;
  waiting: boolean = false;
  WAFR_Workload:any=[];
  workload_name='';
  interval:any='';
  progressValue ='1%';
  clickYes=false;
  demoMsg = "Why is my instance ID (i-083f09e4e6a902a1f) is running slow?";
  demoRes =
    "<b>CloudFront</b> <br><br> Total hits on Cloudfront in the last hour compared <br> to the previous 7 days: 3 <br>Total number of misses in the last hour compared<br> to the previous 7 days: 5 <br>Total number of 500 errors in the last hour compared<br> to the previous 7 days: 5 <br><br> <b>Load Balancer</b> <br><br> Total number of sessions in the last hour compared <br>to the previous 7 days: 5<br> Data out in the last hour compared to the previous 7 days: 7 <br>Check the number of 500 errors in the last hour compared<br> to the previous 7 days: 5 <br><br><b>Database</b><br><br>Total number of vCPU spike utilization in the last hour compared to the previous 7 days: 5 <br>Total RAM utilized in the last hour compared to the previous 7 days: 6<br>Number of connections to the database has maxed out: 7<br><br><b>Correlation</b><br><br>Cloudfront shows that the number of hits in the last 3 hours has increased to 400 compared to the last 30 days. We see a corresponding effect of the same on the number of Sessions in the Load Balancer which has increased at the rate of 50 percentage in the last 6 hours reaching a level of 100 number of sessions. <br><br>Historically, as we see, your application response time degradation starts after the number of hits on your application reaches 70%. That is the time when your instance's CPU and RAM utilization increase by 30 percentage. We have noted that during this time the number of app server threads starts piling up, especially <b>pool-thread-1</b> among others. The function <b>DbConnection</b> seems to be consuming the maximum memory.<br><br>During this time the server application log displays an increase in the which is being thrown by the Class <class name>.<br><br><b>Recommendation:</b> <br><br> 1.Increase the RAM/CPU (as applicable) or Change the instance type to something else<br>2. Solve the exceptions found in the logs<br>3.Review the code and solve which function is consuming more database connection and is apparently locking the same.";
  startYear: string;
  lastYear: string;
  discardMsg = `I'm sorry, but as an AI language model, I don't have access to any specific user's billing information. Please contact AWS customer support for assistance with your billing information.`;
  isbBillingQuesActive=true;
  WAFRquestions: any=[];
  botMessage:any = { };
  refreshBilling=false;
  intervalId:any;
  whitelabelData: any = {
	'pd': {
		'appName': '',
		'logoDark': '',
		'logoLight': '',
	}
};
  // isCopyDone=false;
  constructor(
    private apiServer: APIService,
    public notifier: NotifierService,
    private route: ActivatedRoute
  ) {
    let whitelabelData = localStorage.getItem('whitelabelData');
if(whitelabelData) {
      this.whitelabelData = JSON.parse(whitelabelData);
    }
   }

  ngOnInit(): void {
    this.notifier.disableScroll();
    this.currentMessage = this.notifier.currentMessage.subscribe((msg) => {
      let d = JSON.parse(msg);
      if (d.value == null) {
        return;
      }
      if (d.key == "accountId") {

        this.mId = "";
        this.initloader = true;
        this.isFirstReload = true;
        this.injestGenAiLoader=true;
        this.waiting = false;
        this.isbBillingQuesActive=true;
        this.firstQues=true;
        this.isPresent=true;
        this.WAFR_Workload=[];
        this.WAFRquestions=[];
        this.workload_name='';
        this.interval='';
        this.botMessage = { };
        this.progressValue ='1%';
        this.refreshBilling=false;
        this.accountId = localStorage.getItem("accountId");
        this.selectedAccountId = localStorage.getItem("selectedaccountIds");
        setTimeout(() => {
          this.getMid();
          this.refreshBillingChat();
        }, 200);
      }
    });


    this.socketOpen = false;
    this.connectWebSocket();
  }

  connectWebSocket(): void {
    this.socket = new WebSocket(
      `wss://apis-eks.swayam.cloud/notifications/query/${this.emailId}?account_number=${this.accountId}`
    );

    this.socket.onopen = () => {
      this.isConnectionOpen = true;
      this.socketOpen = true;
    };

    this.socket.onclose = () => {
      this.isConnectionOpen = false;
      this.socketOpen = false;
    };

    this.socket.onerror = (error) => { };

    this.socket.onmessage = (event) => {
      this.botMessage={};
      const fullMessage = event.data;
      let message = fullMessage.split("message: ")[1];
      if (message) {
        message = message.replaceAll("\n", "<br>");
        this.aniCompleted = message && message.trim() != "" ? false : true;
      }
      this.botMessage = {
        text: "",
        animateCompleted: message && message.trim() != "" ? false : true,
        sender: "bot",
        isOpt: false,
        isCopy: true,
        isCopyDone: false,
        isDownload: true,
        textDisplay: message,
        downloadText: message.replaceAll("<br>", "\n"),
        index: 0,
      };
      if (this.botMessage.textDisplay != undefined) {
        this.messages.unshift(this.botMessage);
      }

      if (!this.botMessage["animateCompleted"]) {
        this.printingInProgress = true;
        this.interval='';
        this.interval = setInterval(() => {
          if (
            this.botMessage["textDisplay"].split(" ").length < this.botMessage["index"]
          ) {
            this.botMessage["text"] = this.botMessage["textDisplay"];
            this.botMessage["index"] += 1;
            this.botMessage["animateCompleted"] = true;
            clearInterval(this.interval);
            this.printingInProgress = false;
          } else {
            // let length: number = botMessage['textDisplay'].slice(' ').length;
            this.botMessage["text"] = this.botMessage["textDisplay"]
              .split(" ")
              .slice(0, this.botMessage["index"])
              .join(" ");
              this.botMessage["index"] += 1;
            document.querySelector(".chat-box").scrollTop =
              document.querySelector(".chat-box").scrollHeight;
          }
        }, 50);
      } else {
        document.querySelector(".chat-box").scrollTop =
          document.querySelector(".chat-box").scrollHeight;
      }

      this.waiting = false;
    };
  }

  closeWebSocket(): void {
    if (this.socket && this.isConnectionOpen) {
      this.socket.close();
    }
  }

  openWebSocket(): void {
    if (!this.socket || !this.isConnectionOpen) {
      this.connectWebSocket();
    }
  }
  stopPrinting() { 
    if (this.interval) { 
      this.botMessage["animateCompleted"] = true;
      this.printingInProgress = false; 
      clearInterval(this.interval); 
      
    } } 
  refreshBillingChat() {
    if (this.isBillingActive) {
      this.isFirstReload = false;
      this.isBillingActive = false;
      this.messages = [];
      this.sendDefultMsg('billing_info'); 
    }
    if (this.isWafrActive) {
      this.isFirstReload = false;
      this.isWafrActive = false;
      this.messages = [];
      this.sendDefultMsg('wafr_info'); 
    }
  }

  onFileDropped(event: any) {
    const messageInput = document.getElementById("messageInput");
    event.preventDefault();
    const files = event.dataTransfer.files;
    if (files.length > 0) {
      const file = files[0];
      const message = {
        text: `File uploaded: ${file.name}`,
        textDisplay: `File uploaded: ${file.name}`,
        sender: "user",
        animateCompleted: true,
      };

      messageInput.focus();
      this.messages.unshift(message);
    }

    this.isDraggingFile = false;
  }

  onDragOver(event: any) {
    event.preventDefault();
    this.isDraggingFile = true;
  }
  onDragLeave(event: any) {
    this.isDraggingFile = false;
  }



  async sendDefultMsg(option: any) {
    if (option == "account_info") {
      // if(!this.isAccActive && !this.isManageActive && !this.isSwayamActive){
      if (!this.isAccActive) {
        this.isAccActive = !this.isAccActive;
        this.isManageActive = false;
        this.isSwayamActive = false;
        this.isBillingActive = false;
        this.isWafrActive = false;
        this.isPresent = true;
        this.isbBillingQuesActive=true;
        if(this.intervalId){
          clearInterval(this.intervalId);
        }
        if (!this.isFirstReload) {
          this.closeWebSocket();
          this.selectedOption = "Demo Account";
          this.messages = [];
          this.welcomeMsg = false;
          setTimeout(() => {
            this.openWebSocket();
            setTimeout(() => {
              this.socket.send(option);
            }, 2000);
          }, 2000);
        } else {
          this.socket.send(option);
          this.selectedOption = "Demo Account";
          this.isFirstReload = false;
        }
        this.isQuesloading = true;
        setTimeout(() => {
          let msg =
            "Please note that this functionality is currently limited to using the data from one of Minfy's Internal Accounts. In order to enable this functionality for your account, please drop us an email at <b>support@swayam.cloud</b>.";
          const infoMsg = {
            text: msg,
            sender: "bot",
            isOpt: false,
            isCopy: false,
            isCopyDone: false,
            isDownload: false,
            animateCompleted: true,
            info: true,
            textDisplay: msg,
          };
          this.messages.unshift(infoMsg);

          const message = {
            text: "Sample Questions",
            sender: "bot",
            isOpt: false,
            isCopy: false,
            isCopyDone: false,
            isDownload: false,
            animateCompleted: true,
            textDisplay: "Sample Questions",
          };
          this.messages.unshift(message);

          const options = {
            text: "",
            sender: "",
            isOpt: true,
            isCopy: false,
            isCopyDone: false,
            isDownload: false,
            animateCompleted: true,
            textDisplay: "",
            optList: [
              {
                op: "Why is my instance ID (i-083f09e4e6a902a1f) is running slow?",
              },
              { op: "Tell me about i-035732d798ef3577e instance" },
              { op: "List all the info on DCPVAPPRPT01 instance" },
              { op: "Tell me about the DCPVAPPRPT01 ec2 instance" },
              { op: "List out the details of DCPVAPPRPT01 ec2 instance" },
              { op: "What is the instance id for DCPVAPPRPT01?" },
              {
                op: "How many total volumes are there for ami-0d1ffceb0367fea4c instance?",
              },
              { op: "How many AMIs are there for DCPVAPPRPT01 instance? " },
            ],
          };
          this.isQuesloading = false;
          this.messages.unshift(options);
          setTimeout(() => {
            document.querySelector(".chat-box").scrollTop =
              document.querySelector(".chat-box").scrollHeight;
          }, 10);
        }, 2000);
      } else {
        const message = {
          text: "Demo Account is already selected.",
          sender: "bot",
          isOpt: false,
          isCopy: false,
          isCopyDone: false,
          isDownload: false,
          animateCompleted: true,
          textDisplay: "Demo Account is already selected.",
        };
        this.messages.unshift(message);
        setTimeout(() => {
          document.querySelector(".chat-box").scrollTop =
            document.querySelector(".chat-box").scrollHeight;
        }, 10);
      }
    }
    if (option == "managed_services_info") {
      if (!this.isManageActive) {
        this.isManageActive = !this.isManageActive;
        this.isAccActive = false;
        this.isSwayamActive = false;
        this.isBillingActive = false;
        this.isWafrActive = false;
        this.isPresent = true;
        this.isbBillingQuesActive=true;
        if(this.intervalId){
          clearInterval(this.intervalId);
        }
        if (!this.isFirstReload) {
          this.closeWebSocket();
          this.selectedOption = "Infrastructure Troubleshooting and Support";
          this.messages = [];
          this.welcomeMsg = false;
          setTimeout(() => {
            this.openWebSocket();
            setTimeout(() => {
              this.socket.send(option);
            }, 2000);
          }, 2000);
        } else {
          this.socket.send(option);
          this.selectedOption = "Infrastructure Troubleshooting and Support";
          this.isFirstReload = false;
        }
        this.isQuesloading = true;
        setTimeout(() => {
          const message = {
            text: "Sample Questions",
            sender: "bot",
            isOpt: false,
            isCopy: false,
            isCopyDone: false,
            isDownload: false,
            animateCompleted: true,
            textDisplay: "Sample Questions",
          };
          this.messages.unshift(message);

          const options = {
            text: "",
            sender: "",
            isOpt: true,
            isCopy: false,
            isCopyDone: false,
            isDownload: false,
            animateCompleted: true,
            textDisplay: "",
            optList: [
              {
                op: "What should I do if most of the steps to check my ec2 instance fails?",
              },
              { op: "How do I change my EC2 instance type?" },
              { op: "How can i increase my Elastic IP address limit?" },
              { op: "Why can't i connect to my RDS DB instance" },
              { op: "Why is there high latency on my ELB" },
              { op: "How can I prevent SSH attacks on my instances?" },
            ],
          };
          this.isQuesloading = false;
          this.messages.unshift(options);
          setTimeout(() => {
            document.querySelector(".chat-box").scrollTop =
              document.querySelector(".chat-box").scrollHeight;
          }, 10);
        }, 2000);
      } else {
        const message = {
          text: "Infrastructure Troubleshooting and Support is already selected.",
          sender: "bot",
          isOpt: false,
          isCopy: false,
          isCopyDone: false,
          isDownload: false,
          animateCompleted: true,
          textDisplay:
            "Infrastructure Troubleshooting and Support is already selected.",
        };
        this.messages.unshift(message);
        setTimeout(() => {
          document.querySelector(".chat-box").scrollTop =
            document.querySelector(".chat-box").scrollHeight;
        }, 10);
      }
    }
    if (option == "minfylabs") {
      if (!this.isSwayamActive) {
        this.isSwayamActive = !this.isSwayamActive;
        this.isManageActive = false;
        this.isAccActive = false;
        this.isBillingActive = false;
        this.isWafrActive = false;
        this.isPresent = true;
        this.isbBillingQuesActive=true;
        if(this.intervalId){
          clearInterval(this.intervalId);
        }
        if (!this.isFirstReload) {
          this.closeWebSocket();
          this.selectedOption = "About";
          this.messages = [];
          this.welcomeMsg = false;
          setTimeout(() => {
            this.openWebSocket();
            setTimeout(() => {
              this.socket.send(option);
            }, 2000);
          }, 2000);
        } else {
          this.socket.send(option);
          this.selectedOption = "About";
          this.isFirstReload = false;
        }
        this.isQuesloading = true;
        setTimeout(() => {
          const message = {
            text: "Sample Questions",
            sender: "bot",
            isOpt: false,
            isCopy: false,
            isCopyDone: false,
            isDownload: false,
            animateCompleted: true,
            textDisplay: "Sample Questions",
          };
          this.messages.unshift(message);

          const options = {
            text: "",
            sender: "",
            isOpt: true,
            isCopy: false,
            isCopyDone: false,
            isDownload: false,
            animateCompleted: true,
            textDisplay: "",
            optList: [
              { op: `About` },
              { op: `How can I manage my bills with this product?` },
              { op: `How do I get support from this product?` },
              { op: `How do I onboard an account?` },
              { op: `List out all the features` },
            ],
          };
          this.isQuesloading = false;
          this.messages.unshift(options);
          setTimeout(() => {
            document.querySelector(".chat-box").scrollTop =
              document.querySelector(".chat-box").scrollHeight;
          }, 10);
        }, 2000);
      } else {
        const message = {
          text: `About is already selected.`,
          sender: "bot",
          isOpt: false,
          isCopy: false,
          isCopyDone: false,
          isDownload: false,
          animateCompleted: true,
          textDisplay: `About is already selected.`,
        };
        this.messages.unshift(message);
        setTimeout(() => {
          document.querySelector(".chat-box").scrollTop =
            document.querySelector(".chat-box").scrollHeight;
        }, 10);
      }
    }
    if (option == "billing_info") {
      // if(!this.isAccActive && !this.isManageActive && !this.isSwayamActive){
      if (!this.isBillingActive) {
        setTimeout(() => {
          this.isBillingActive = !this.isBillingActive;
        },350);
        this.isAccActive = false;
        this.isManageActive = false;
        this.isSwayamActive = false;
        this.isWafrActive = false;
        this.isPresent = false;
        this.firstQues=true;
        
        let updatedOpt: string = this.accountId + '_' + option;
        
      //  const status = this.isCollectionValid(updatedOpt);

        //checking execution status
        let header = {
          Authorization: "Bearer " + localStorage.getItem("t"),
        };
    
        let apiURL = `https://apis-eks.swayam.cloud/global_notification/check_stepfunction_status/?account_number=${this.accountId}&category=billing&user_type=client`;
        let executionStatus=''
       
        let apiResult = await this.apiServer.postDataPromis(apiURL, {}, header).then((data)=>{
          try {
            executionStatus = data['accounts_ids'][this.accountId]['message'];
          } catch (error) {
            executionStatus = data['detail'];
           const dateRange =  executionStatus.match(/(\d{4}-\d{2}-\d{2}_\d{4}-\d{2}-\d{2})/);
          //  if (dateRange) {
          //   const [startDate, endDate] = dateRange[0].split('_'); 
          //   const formattedStartDate = moment(startDate).format('Do MMM YYYY'); 
          //   const formattedEndDate = moment(endDate).format('Do MMM YYYY');
          //   this.startYear = formattedStartDate;
          //   this.lastYear = formattedEndDate;
          //   console.log(this.startYear);
          //  }
          }
         console.log(executionStatus);
        });
  
        let apiURL2 = `https://apis-eks.swayam.cloud/global_notification/check_latest_date_for_ingested_data/?account_number=${this.accountId}&category=billing&user_type=client `;

        await this.apiServer.postDataPromis(apiURL2, {}, header).then((data)=>{
          try {
            let res = data['accounts_ids'][this.accountId];
            const startDate = res['from_date'];
            const endDate = res['to_date'];
            const formattedStartDate = moment(startDate).format('Do MMM YYYY'); 
            const formattedEndDate = moment(endDate).format('Do MMM YYYY');
            this.startYear = formattedStartDate;
            this.lastYear = formattedEndDate;
          } catch (error) {
            
          }
        });

        if (!this.isFirstReload) {
          this.selectedOption = "Billing";

       //  if(this.isPresent){
         
          this.closeWebSocket(); 
          this.messages = [];
          this.welcomeMsg = false;
          setTimeout(() => {
            this.openWebSocket();
            setTimeout(() => {
              this.socket.send(updatedOpt);
            }, 2000);
          }, 2000);
       // }

        } else {
         // if(this.isPresent){
    
            this.socket.send(updatedOpt);
         // }
          
          this.selectedOption = "Billing";
          this.isFirstReload = false;
        }
        // this.isCollectionValid(updatedOpt);

        this.isQuesloading = true;
        setTimeout(async () => {
          // let msg =
          //   "Please note that this functionality is currently limited to using the data from one of Minfy's Internal Accounts. In order to enable this functionality for your account, please drop us an email at <b>support@swayam.cloud</b>.";
          // const infoMsg = {
          //   text: msg,
          //   sender: "bot",
          //   isOpt: false,
          //   isCopy: false,
          //   isCopyDone: false,
          //   isDownload: false,
          //   animateCompleted: true,
          //   info: true,
          //   textDisplay: msg,
          // };
          // this.messages.unshift(infoMsg);
          // if(this.isbBillingQuesActive){
          //   this.isbBillingQuesActive=false;

          if(executionStatus !== 'RUNNING' && executionStatus !== 'FAILED' && executionStatus !== 'SUCCEEDED' && this.refreshBilling!==true){
          let msg2 =
            `--`;
          const firstMsg = {
            text: msg2,
            sender: "bot",
            isOpt: false,
            isCopy: false,
            isCopyDone: false,
            isDownload: false,
            animateCompleted: true,
            info: true,
            firstMsg: true,
            textDisplay: msg2,
          };
          this.messages.unshift(firstMsg);
          
          setTimeout(() => {
            document.querySelector(".chat-box").scrollTop =
              document.querySelector(".chat-box").scrollHeight;
          }, 10);
          
        }

        const message2 = {
          text: `Billing data is available from ${this.startYear} to ${this.lastYear}, Please Proceed further.`,
          sender: "bot",
          isOpt: false,
          isCopy: false,
          isCopyDone: false,
          isDownload: false,
          info: true,
          animateCompleted: true,
          textDisplay: `Billing data is available from ${this.startYear} to ${this.lastYear}, Please Proceed further.`,
        };
        if(executionStatus === 'SUCCEEDED' || this.refreshBilling){
        this.messages.unshift(message2);
        }

          const message = {
            text: "Sample Questions",
            sender: "bot",
            isOpt: false,
            isCopy: false,
            isCopyDone: false,
            isDownload: false,
            animateCompleted: true,
            textDisplay: "Sample Questions",
          };
          if(executionStatus === 'SUCCEEDED' || this.refreshBilling){
          this.messages.unshift(message);
          }
          // if(this.refreshBilling){
          //   this.messages.unshift(message);
          //   }
          const options = {
            text: "",
            sender: "",
            isOpt: true,
            isCopy: false,
            isCopyDone: false,
            isDownload: false,
            animateCompleted: true,
            textDisplay: "",
            optList: [
              { op: "Explain the bills for 1st Jan" },
              { op: "Provide the costs for the first week of May" },
              {
                op: "Give me some insights based on the various AWS Services. Answer in bullet points",
              },
              { op: "What are the most expensive services?" },
              {
                op: "Among the AWS services, which have cost that stands out?",
              },
              {
                op: "Based on the services with highest costs, how can i optimize my AWS bill",
              },
            ],
          };

          if(executionStatus === 'SUCCEEDED' || this.refreshBilling){
           this.messages.unshift(options);
           this.firstQues=false;
          }
          // if(this.refreshBilling){
          //   this.messages.unshift(options);
          //   this.firstQues=false;
          //   }
          
         else if(executionStatus === 'FAILED'){
          this.initloader = false;
        let msg =
        "The GenAI Data ingestion has failed due to some internal error. We will check it internally and get back to you. If you wish to reach out to us, please drop us an email at <b>support@swayam.cloud</b>.";
      const infoMsg = {
        text: msg,
        sender: "bot",
        isOpt: false,
        isCopy: false,
        isCopyDone: false,
        isDownload: false,
        animateCompleted: true,
        info: true,
        textDisplay: msg,
      };
      this.messages.unshift(infoMsg);
      setTimeout(() => {
        document.querySelector(".chat-box").scrollTop =
          document.querySelector(".chat-box").scrollHeight;
      }, 10);
         }

         else if(executionStatus === 'RUNNING'){
          console.log(this.intervalId);
          this.injestGenAiLoader=true;
    const infoMsg2 = {
      text: '',
      sender: "bot",
      isOpt: false,
      isCopy: false,
      isCopyDone: false,
      isDownload: false,
      animateCompleted: true,
      info: false,
      injestGenAi: true,
      textDisplay: '',
    };
    this.messages.unshift(infoMsg2);
    setTimeout(() => {
      document.querySelector(".chat-box").scrollTop =
        document.querySelector(".chat-box").scrollHeight;
    }, 10);

    setTimeout(() => {
      try {
           
      
        //checking status
        let counter = 0; 
        const maxIterations = 60;
        let status="";
        const progress = document.getElementById('progress');
        console.log(progress);
        progress.classList.remove("w-6");
        progress.classList.remove("w-11");
        progress.classList.remove("w-16");
        progress.classList.remove("w-21");
        progress.classList.remove("w-26");
        progress.classList.remove("w-31");
        progress.classList.remove("w-36");
        progress.classList.remove("w-41");
        progress.classList.remove("w-46");
        progress.classList.remove("w-51");
        progress.classList.remove("w-56");
        progress.classList.remove("w-61");
        progress.classList.remove("w-66");
        progress.classList.remove("w-71");
        progress.classList.remove("w-76");
        progress.classList.remove("w-81");
        progress.classList.remove("w-86");
        progress.classList.add("w-99");
        this.progressValue =`99%`;
        this.intervalId = setInterval(async () => {
        
          let header = {
            Authorization: "Bearer " + localStorage.getItem("t"),
          };
  
          let apiURL = `https://apis-eks.swayam.cloud/global_notification/check_stepfunction_status/?account_number=${this.accountId}&category=billing&user_type=client`;
  
  
         await this.apiServer.postDataPromis(apiURL, {}, header).then((data) => {
            status = data['accounts_ids'][this.accountId]['message'];
          });
          
          counter++;
          if (counter >= maxIterations || status === 'FAILED' || status === 'SUCCEEDED') {
           
            if(status === 'SUCCEEDED'){
              progress.classList.remove(`w-99`);
              progress.classList.remove(`progress-bar-striped`);
              progress.classList.remove(`progress-blue`);
              progress.classList.add(`bg-success`);
              progress.classList.add(`w-100`);
              this.progressValue =`100%`;
            }
  
            if(status === 'FAILED'){
              
              progress.classList.remove(`progress-bar-striped`);
              progress.classList.remove(`progress-blue`);
              progress.classList.add(`bg-danger`);
  
            }

            clearInterval(this.intervalId);
           
            this.injestGenAiLoader = false;
            this.afterIntervalComplete(status);
            
          }
        }, 10000);  
        
      } catch (error) {
        this.injestGenAiLoader=false;
      }
    }, 1000);
         
         }
       // }

        else if (executionStatus.includes('id not Found.')) {
          let msg2 =
            `--`;
          const infoMsg2 = {
            text: msg2,
            sender: "bot",
            isOpt: false,
            isCopy: false,
            isCopyDone: false,
            isDownload: false,
            animateCompleted: true,
            info: true,
            click: true,
            textDisplay: msg2,
          };
         // this.messages.unshift(infoMsg2);
         // this.checkForBillingData();
            }
          this.isQuesloading = false;
          setTimeout(() => {
            document.querySelector(".chat-box").scrollTop =
              document.querySelector(".chat-box").scrollHeight;
          }, 10);
        }, 2000);
      } else {
        const message = {
          text: "Billing is already selected.",
          sender: "bot",
          isOpt: false,
          isCopy: false,
          isCopyDone: false,
          isDownload: false,
          animateCompleted: true,
          textDisplay: "Billing is already selected.",
        };
        this.messages.unshift(message);
        setTimeout(() => {
          document.querySelector(".chat-box").scrollTop =
            document.querySelector(".chat-box").scrollHeight;
        }, 10);
      }
    }
    if (option == "wafr_info") {
      // if(!this.isAccActive && !this.isManageActive && !this.isSwayamActive){
      if (!this.isWafrActive) {
        setTimeout(() => {
          this.isWafrActive = !this.isWafrActive;
        }, 350);
        this.isBillingActive = false;
        this.isAccActive = false;
        this.isManageActive = false;
        this.isSwayamActive = false;
        this.isPresent = false;
        if(this.intervalId){
          clearInterval(this.intervalId);
        }
        let updatedOpt: string = this.accountId + '_' + option;
        
        const status = this.isCollectionValid(updatedOpt);
        if (!this.isFirstReload) {
          this.selectedOption = "WAFR";
          if(this.isPresent){
          this.closeWebSocket();
          this.messages = [];
          this.welcomeMsg = false;
          setTimeout(() => {
            this.openWebSocket();
            setTimeout(() => {
              this.socket.send(option);
            }, 2000);
          }, 2000);
        }
        } else {
          if(this.isPresent){
          this.socket.send(option);
          }
          this.selectedOption = "WAFR";
          this.isFirstReload = false;
        }
        this.isQuesloading = true;
        setTimeout(() => {
          let msg =
            "Please note that this functionality is currently limited to using the data from one of Minfy's Internal Accounts. In order to enable this functionality for your account, please drop us an email at <b>support@swayam.cloud</b>.";
          const infoMsg = {
            text: msg,
            sender: "bot",
            isOpt: false,
            isCopy: false,
            isCopyDone: false,
            isDownload: false,
            animateCompleted: true,
            info: true,
            textDisplay: msg,
          };
          this.messages.unshift(infoMsg);
          const message = {
            text: "Sample Questions",
            sender: "bot",
            isOpt: false,
            isCopy: false,
            isCopyDone: false,
            isDownload: false,
            animateCompleted: true,
            textDisplay: "Sample Questions",
          };
          this.messages.unshift(message);

          const options = {
            text: "",
            sender: "",
            isOpt: true,
            isCopy: false,
            isCopyDone: false,
            isDownload: false,
            animateCompleted: true,
            textDisplay: "",
            optList: [
              { op: "What are the WAFR questions regarding Sustainability?" },
              {
                op: "Which individual pillar is at the highest risk compared to others?",
              },
              {
                op: "Give me 5 key plans for improvement regarding Sustainability",
              },
              {
                op: "Summarize the report and suggest remediation for the issues identified",
              },
              {
                op: "How many questions were answered for the 6 pillars? Give the answer in tabular form",
              },
            ],
          };
          
          this.messages.unshift(options);

          if (!this.isPresent) {
            let msg2 =
              `--`;
            const infoMsg2 = {
              text: msg2,
              sender: "bot",
              isOpt: false,
              isCopy: false,
              isCopyDone: false,
              isDownload: false,
              animateCompleted: true,
              info: true,
              wClick: true,
              textDisplay: msg2,
            };
            this.messages.unshift(infoMsg2);
              }
              this.isQuesloading = false;
          setTimeout(() => {
            document.querySelector(".chat-box").scrollTop =
              document.querySelector(".chat-box").scrollHeight;
          }, 10);
        }, 2000);
      } else {
        const message = {
          text: "WAFR is already selected.",
          sender: "bot",
          isOpt: false,
          isCopy: false,
          isCopyDone: false,
          isDownload: false,
          animateCompleted: true,
          textDisplay: "WAFR is already selected.",
        };
        this.messages.unshift(message);
        setTimeout(() => {
          document.querySelector(".chat-box").scrollTop =
            document.querySelector(".chat-box").scrollHeight;
        }, 10);
      }
    }

  }

  yesBilling(){
    let msg2 =
            `--`;
          const infoMsg2 = {
            text: msg2,
            sender: "bot",
            isOpt: false,
            isCopy: false,
            isCopyDone: false,
            isDownload: false,
            animateCompleted: true,
            info: true,
            click: true,
            textDisplay: msg2,
          };
          this.messages.unshift(infoMsg2);
          this.checkForBillingData();
          setTimeout(() => {
            document.querySelector(".chat-box").scrollTop =
              document.querySelector(".chat-box").scrollHeight;
          }, 10);
  }

//------------WAFR-----------
  async checkForWAFRData(event: Event){
    this.initloader = true;
    const infoMsg2 = {
      text: ' ',
      sender: "bot",
      isOpt: false,
      isCopy: false,
      isCopyDone: false,
      isDownload: false,
      animateCompleted: true,
      info: false,
      wInit: true,
      textDisplay: ' ',
    };
    this.messages.unshift(infoMsg2);
    setTimeout(() => {
      document.querySelector(".chat-box").scrollTop =
        document.querySelector(".chat-box").scrollHeight;
    }, 10);
  this.WAFR_Workload=[];
  this.workload_name='';
  let data: any = {
    action: "list_workloads",
    account_id: this.accountId,
    region_id: this.regionId,
    id_token: localStorage.getItem("idT"),
  };

  let headers: any = {
    Authorization: localStorage.getItem("t"),
  };

  let apiURL: string = `${environment.apiURL}/${this.urlPrefix}/war/operations`;

  let result = await this.apiServer.postDataPromis(apiURL, data, headers);
  this.WAFR_Workload=result.workloads;
  if(this.WAFR_Workload.length!=0){
    this.workload_name=this.WAFR_Workload[this.WAFR_Workload.length-1].name;
      this.fetchWAFRQues();
  }else{
    let msg =
    "Sorry, No WAFR Workload found!";
  const infoMsg = {
    text: msg,
    sender: "bot",
    isOpt: false,
    isCopy: false,
    isCopyDone: false,
    isDownload: false,
    animateCompleted: true,
    info: true,
    textDisplay: msg,
  };
  this.messages.unshift(infoMsg);
  setTimeout(() => {
    document.querySelector(".chat-box").scrollTop =
      document.querySelector(".chat-box").scrollHeight;
  }, 10);
  this.initloader = false;
  }
  
}

  async fetchWAFRQues(){
   this.WAFRquestions=[];
  let data: any = {
    action: "get_workload_questions",
    workload_id: this.WAFR_Workload[this.WAFR_Workload.length-1]["id"]
  };

  let headers: any = {
    Authorization: localStorage.getItem("t"),
  };

  let apiURL: string = `${environment.apiURL}/${this.urlPrefix}/war/operations`;

  let result = await this.apiServer.postDataPromis(apiURL, data, headers);

  if (result.status == "1" || result.s == "1") {
    
    this.WAFRquestions = result.questions;
    const infoMsg2 = {
      text: ' ',
      sender: "bot",
      isOpt: false,
      isCopy: false,
      isCopyDone: false,
      isDownload: false,
      animateCompleted: true,
      info: false,
      wfound: true,
      textDisplay: ' ',
    };
    this.messages.unshift(infoMsg2);
    setTimeout(() => {
      document.querySelector(".chat-box").scrollTop =
        document.querySelector(".chat-box").scrollHeight;
    }, 10);
    this.initloader = false;
}
this.initloader = false;
}

fetchTotalAnsweredQuestions() {
  return this.WAFRquestions.filter((question: any) => {
    return question["Risk"] != "UNANSWERED";
  });
}
//------------Billing----------
  checkForBillingData() {
    this.initloader = true;
    this.clickYes=true;
    const infoMsg2 = {
      text: ' ',
      sender: "bot",
      isOpt: false,
      isCopy: false,
      isCopyDone: false,
      isDownload: false,
      animateCompleted: true,
      info: false,
      init: true,
      textDisplay: ' ',
    };
    this.messages.unshift(infoMsg2);
    setTimeout(() => {
      document.querySelector(".chat-box").scrollTop =
        document.querySelector(".chat-box").scrollHeight;
    }, 10);

    //this.getMid();
    
    setTimeout(async () => {
      if (this.mId != null) {
        let months;
        months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((value: any) => {
          let month: string = moment()
            .subtract(12 - value, "months")
            .format("YYYY-MM");
          return month;
        });
        // this.startYear=months[0];
        // this.lastYear=months[11];
        let data = {
          a: "fetchMonthlyTotalCost",
          mId: this.mId,
          lId: this.accountId,
          ml: months,
        };


        let header = {
          Authorization: localStorage.getItem("t"),
        };

        let apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/billing/fetchdailybillingdetails`;

    if(this.customerType == 'mp') {
      apiURL = `${APIService.API_ENDPOINTV3}/market/billing/daily`
    }

        let result = await this.apiServer.postDataPromis(apiURL, data, header);
        
        if (result.s == "1" && result.documentsData.length > 0) {
          this.initloader = false;
          try {
            this.injestBillingToGenAI();
          } catch (error) {

          }

          // console.log(formData);

          
        } else {

          this.initloader = false;
          let msg =
          "The GenAI Data ingestion has failed due to some internal error. We will check it internally and get back to you. If you wish to reach out to us, please drop us an email at <b>support@swayam.cloud</b>.";
        const infoMsg = {
          text: msg,
          sender: "bot",
          isOpt: false,
          isCopy: false,
          isCopyDone: false,
          isDownload: false,
          animateCompleted: true,
          info: true,
          textDisplay: msg,
        };
        this.messages.unshift(infoMsg);
        setTimeout(() => {
          document.querySelector(".chat-box").scrollTop =
            document.querySelector(".chat-box").scrollHeight;
        }, 10);
        }


      } else {
        this.initloader = false;
        let msg =
        "The GenAI Data ingestion has failed due to some internal error. We will check it internally and get back to you. If you wish to reach out to us, please drop us an email at <b>support@swayam.cloud</b>.";
      const infoMsg = {
        text: msg,
        sender: "bot",
        isOpt: false,
        isCopy: false,
        isCopyDone: false,
        isDownload: false,
        animateCompleted: true,
        info: true,
        textDisplay: msg,
      };
      this.messages.unshift(infoMsg);
      setTimeout(() => {
        document.querySelector(".chat-box").scrollTop =
          document.querySelector(".chat-box").scrollHeight;
      }, 10);
      }
    }, 2000);
  }

  async injestBillingToGenAI() {
    this.injestGenAiLoader=true;
    const infoMsg2 = {
      text: '',
      sender: "bot",
      isOpt: false,
      isCopy: false,
      isCopyDone: false,
      isDownload: false,
      animateCompleted: true,
      info: false,
      injestGenAi: true,
      textDisplay: '',
    };
    this.messages.unshift(infoMsg2);
    setTimeout(() => {
      document.querySelector(".chat-box").scrollTop =
        document.querySelector(".chat-box").scrollHeight;
    }, 10);

    try {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("t"),
      };
  
      const authToken = "Bearer " + localStorage.getItem("t");
  
      let apiURL = `https://apis-eks.swayam.cloud/global_notification/invoke_to_stepfunction/?auth_token=${authToken} &account_number=${this.accountId}&category=billing&user_type=client&aws_region=ap-south-1 `;
      
      let exId="";
      let apiResult = await this.apiServer.postDataPromis(apiURL, {}, header).then((data)=>{
        exId= data['accounts_ids'][this.accountId]['message'];
      });

      //checking status
      let counter = 0; 
      const maxIterations = 60;
      let status="";
      const progress = document.getElementById('progress');
      let width = 1;
       this.intervalId = setInterval(() => {
        console.log(width);
        width = width+5;
        console.log(width);
        if(width <= 86){
         
         progress.classList.remove(`w-${width-5}`);
         progress.classList.add(`w-${width}`);
         this.progressValue =`${width}%`;
        }
        else{
          progress.classList.remove(`w-${width-5}`);
         progress.classList.add(`w-99`);
         this.progressValue =`99%`;
        }
        let header = {
          Authorization: "Bearer " + localStorage.getItem("t"),
        };

        let apiURL = `https://apis-eks.swayam.cloud/global_notification/check_stepfunction_status/?account_number=${this.accountId}&category=billing&user_type=client`;


        let apiResult = this.apiServer.postDataPromis(apiURL, {}, header).then((data) => {
          status = data['accounts_ids'][this.accountId]['message'];
        });
        
        counter++;
        if (counter >= maxIterations || status === 'FAILED' || status === 'SUCCEEDED') {
          if(status === 'SUCCEEDED'){
            progress.classList.remove(`w-99`);
            progress.classList.remove(`progress-bar-striped`);
            progress.classList.remove(`progress-blue`);
            progress.classList.add(`bg-success`);
            progress.classList.add(`w-100`);
            this.progressValue =`100%`;
          }

          if(status === 'FAILED'){
            
            progress.classList.remove(`progress-bar-striped`);
                  progress.classList.remove(`progress-blue`);
                  progress.classList.add(`bg-danger`);

          }

          clearInterval(this.intervalId);
         
          this.injestGenAiLoader = false;
          this.afterIntervalComplete(status);
          
        }
      }, 10000);  
      
    } catch (error) {
      this.injestGenAiLoader=false;
    }
    
  }

afterIntervalComplete(status:any){

  
  //display message
  if(!this.injestGenAiLoader){
 //  status='SUCCEEDED';
    if(status=='FAILED'){
      let msg =
      "The GenAI Data ingestion has failed due to some internal error. We will check it internally and get back to you. If you wish to reach out to us, please drop us an email at <b>support@swayam.cloud</b>.";
    const infoMsg = {
      text: msg,
      sender: "bot",
      isOpt: false,
      isCopy: false,
      isCopyDone: false,
      isDownload: false,
      animateCompleted: true,
      info: true,
      textDisplay: msg,
    };
    this.messages.unshift(infoMsg);
    setTimeout(() => {
      document.querySelector(".chat-box").scrollTop =
        document.querySelector(".chat-box").scrollHeight;
    }, 10);
    }
    if(status=='SUCCEEDED'){
      const infoMsg2 = {
        text: '',
        sender: "bot",
        isOpt: false,
        isCopy: false,
        isCopyDone: false,
        isDownload: false,
        animateCompleted: true,
        info: false,
        doneRefresh: true,
        textDisplay: '',
      };
      this.messages.unshift(infoMsg2);
      setTimeout(() => {
        document.querySelector(".chat-box").scrollTop =
          document.querySelector(".chat-box").scrollHeight;
      }, 10);
    }
  }
}
refreshPage(event:Event){
  if (this.isBillingActive) {
    this.isFirstReload = false;
    this.isBillingActive = false;
    this.refreshBilling=true;
    this.messages = [];
    this.sendDefultMsg('billing_info');
  }
}
  async getMid() {
    let data = {
      lid: this.accountId,
      userType: "C",
      action: "fetchMasterAccList",
    };

    let header = {
      Authorization: localStorage.getItem("t"),
    };
    let apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/billing/ec2breakup`;
    
    if(this.customerType == 'mp') {
      apiURL = `${APIService.API_ENDPOINTV3}/market/billing/subdetails`;
    }

    if(environment.envName == 'Development' && this.urlPrefix == 'admin') {
      apiURL = `${environment.apiURL}/${this.urlPrefix}/billing/ec2breakup`
    }

    let result = await this.apiServer.postDataPromis(apiURL, data, header);

    if (result.status == "1" || result.s == "1") {
      this.mId = result.masterAccList[0];
    } else {
      this.mId = null;
     
    }
  }




  isCollectionValid(collection: string): boolean {
    let apiURL = `https://apis-eks.swayam.cloud/global_notification/check_chromadb_collections/?collection_name=${collection}&user_type=internal`;

    let header = {
      Authorization: "Bearer " + localStorage.getItem("t"),
    };
    this.isPresent = true;
   let ispresent=true;
    try {
    this.apiServer.postDataPromis(apiURL, {}, header).then((data) => {
      
       
        if (data['detail']) {
          ispresent=false;
          this.isPresent = false;
        } else {
          
          
          ispresent=true;
          this.isPresent = true;
        }
     
    });
  } catch (error) {
    this.isPresent = false;
  }
 
    return ispresent;
  }
  sendQuestion(ques: any) {
    if (!this.printingInProgress) {
      if (this.demoMsg != ques) {
        this.socket.send(ques);
        const message = {
          text: ques,
          sender: "user", // assume the user sent the message
          isOpt: false,
          isCopy: false,
          isCopyDone: false,
          isDownload: false,
          animateCompleted: true,
          textDisplay: ques,
        };
        this.messages.unshift(message);
        this.newMessage = "";
        this.waiting = true;
        setTimeout(() => {
          document.querySelector(".chat-box").scrollTop =
            document.querySelector(".chat-box").scrollHeight;
        }, 10);
      } else {
        const message = {
          text: ques,
          isOpt: false,
          isCopy: false,
          isCopyDone: false,
          isDownload: false,
          sender: "user", // assume the user sent the message
          animateCompleted: true,
          textDisplay: ques,
        };
        this.messages.unshift(message);
        // this.newMessage = "";
        this.waiting = true;
        setTimeout(() => {
          document.querySelector(".chat-box").scrollTop =
            document.querySelector(".chat-box").scrollHeight;
        }, 10);
        this.sendDemoRes();
      }
    }
  }

  sendMessage() {
    if (this.newMessage && this.newMessage.trim() !== "") {
      if (this.demoMsg != this.newMessage) {
        if (
          this.isAccActive ||
          this.isManageActive ||
          this.isSwayamActive ||
          this.isWafrActive ||
          this.isBillingActive
        ) {
          this.socket.send(this.newMessage);
          const message = {
            text: this.newMessage,
            isOpt: false,
            isCopy: false,
            isCopyDone: false,
            isDownload: false,
            sender: "user", // assume the user sent the message
            animateCompleted: true,
            textDisplay: this.newMessage,
          };
          this.messages.unshift(message);
          this.newMessage = "";
          this.waiting = true;
          setTimeout(() => {
            document.querySelector(".chat-box").scrollTop =
              document.querySelector(".chat-box").scrollHeight;
          }, 10);
        } else {
          const message = {
            text: "Please select category.",
            isOpt: false,
            isCopy: false,
            isCopyDone: false,
            isDownload: false,
            sender: "bot", // assume the user sent the message
            animateCompleted: true,
            textDisplay: "Please select category.",
          };
          this.messages.unshift(message);
          this.newMessage = "";
          this.waiting = false;
          setTimeout(() => {
            document.querySelector(".chat-box").scrollTop =
              document.querySelector(".chat-box").scrollHeight;
          }, 10);
        }
      } else {
        const message = {
          text: this.newMessage,
          isOpt: false,
          isCopy: false,
          isCopyDone: false,
          isDownload: false,
          sender: "user", // assume the user sent the message
          animateCompleted: true,
          textDisplay: this.newMessage,
        };
        this.messages.unshift(message);
        this.newMessage = "";
        this.waiting = true;
        setTimeout(() => {
          document.querySelector(".chat-box").scrollTop =
            document.querySelector(".chat-box").scrollHeight;
        }, 10);
        this.sendDemoRes();
      }
    }

    //   console.log(this.newMessage);
    //   const message = {
    //     text: this.newMessage,
    //     sender: 'user' // assume the user sent the message
    //   };
    //   this.messages.unshift(message);
    //   this.newMessage = '';
    //   // call your Langchain/OpenAI API here to get a response
    //   // assume the response is stored in a variable called 'response'
    //   const botMessage = {
    //     text: 'response',
    //     sender: 'bot' // assume the bot sent the response
    //   };
    //   this.messages.unshift(botMessage);
  }

  sendDemoRes() {
    // const fullMessage = this.demoRes;
    let initMsg = `Initializing Checks &nbsp;<img src="../assets/img/loading_2.svg" alt="loading scans"
   width="18px" />`;

    setTimeout(() => {
      const botMessage = {
        text: "",
        animateCompleted: initMsg && initMsg.trim() != "" ? false : true,
        sender: "bot",
        isOpt: false,
        isCopy: false,
        isCopyDone: false,
        isDownload: false,
        textDisplay: initMsg,
        index: 0,
      };

      if (botMessage.textDisplay != undefined) {
        this.messages.unshift(botMessage);
      }

      if (!botMessage["animateCompleted"]) {
        this.printingInProgress = true;
        let interval: any = setInterval(() => {
          if (
            botMessage["textDisplay"].split(" ").length < botMessage["index"]
          ) {
            botMessage["text"] = botMessage["textDisplay"];
            botMessage["index"] += 1;
            botMessage["animateCompleted"] = true;
            clearInterval(interval);
            this.printingInProgress = false;
          } else {
            // let length: number = botMessage['textDisplay'].slice(' ').length;
            botMessage["text"] = botMessage["textDisplay"]
              .split(" ")
              .slice(0, botMessage["index"])
              .join(" ");
            botMessage["index"] += 1;
            document.querySelector(".chat-box").scrollTop =
              document.querySelector(".chat-box").scrollHeight;
          }
        }, 0);

        //---------------------
        setTimeout(() => {
          this.initMsgUpdate();

          setTimeout(() => {
            this.finalres();
          }, 5000);
        }, 10000);

        //-----------------------------
      } else {
        document.querySelector(".chat-box").scrollTop =
          document.querySelector(".chat-box").scrollHeight;
      }

      this.waiting = false;

      // this.messages[0]['textDisplay']="Initializing Checks";
    }, 2000);
  }

  initMsgUpdate() {
    let updateText = `Initializing Checks &nbsp; <i class="fa-solid fa-circle-check" class="text-success"></i>`;
    const botMessage2 = {
      text: updateText,
      animateCompleted: true,
      sender: "bot",
      isOpt: false,
      isCopy: false,
      isCopyDone: false,
      isDownload: false,
      textDisplay: updateText,
      index: 0,
    };
    this.messages[0] = botMessage2;

    //for 2nd msg
    let initMsg = `Here are the results &nbsp;<img src="../assets/img/loading_2.svg" alt="loading scans"
      width="18px" />`;

    const botMessage = {
      text: "",
      animateCompleted: initMsg && initMsg.trim() != "" ? false : true,
      sender: "bot",
      isOpt: false,
      isCopy: false,
      isCopyDone: false,
      isDownload: false,
      textDisplay: initMsg,
      index: 0,
    };

    if (botMessage.textDisplay != undefined) {
      this.messages.unshift(botMessage);
    }

    if (!botMessage["animateCompleted"]) {
      this.printingInProgress = true;
      let interval: any = setInterval(() => {
        if (botMessage["textDisplay"].split(" ").length < botMessage["index"]) {
          botMessage["text"] = botMessage["textDisplay"];
          botMessage["index"] += 1;
          botMessage["animateCompleted"] = true;
          clearInterval(interval);
          this.printingInProgress = false;
        } else {
          // let length: number = botMessage['textDisplay'].slice(' ').length;
          botMessage["text"] = botMessage["textDisplay"]
            .split(" ")
            .slice(0, botMessage["index"])
            .join(" ");
          botMessage["index"] += 1;
          document.querySelector(".chat-box").scrollTop =
            document.querySelector(".chat-box").scrollHeight;
        }
      }, 0);
    } else {
      document.querySelector(".chat-box").scrollTop =
        document.querySelector(".chat-box").scrollHeight;
    }

    this.waiting = false;
  }

  finalres() {
    const botMessage2 = {
      text: "Here are the results :",
      animateCompleted: true,
      sender: "bot",
      isOpt: false,
      isCopy: false,
      isCopyDone: false,
      isDownload: false,
      textDisplay: "Here are the results :",
      index: 0,
    };
    this.messages[0] = botMessage2;

    let message = this.demoRes;
    const botMessage = {
      text: "",
      animateCompleted: message && message.trim() != "" ? false : true,
      sender: "bot",
      isOpt: false,
      isCopy: true,
      isCopyDone: false,
      isDownload: true,
      textDisplay: message,
      downloadText: message
        .replace(/<br>/g, "\n")
        .replace(/<b>/g, "")
        .replace(/<\/b>/g, ""),
      index: 0,
    };

    if (botMessage.textDisplay != undefined) {
      this.messages.unshift(botMessage);
    }

    if (!botMessage["animateCompleted"]) {
      this.printingInProgress = true;
      let interval: any = setInterval(() => {
        if (botMessage["textDisplay"].split(" ").length < botMessage["index"]) {
          botMessage["text"] = botMessage["textDisplay"];
          botMessage["index"] += 1;
          botMessage["animateCompleted"] = true;
          clearInterval(interval);
          this.printingInProgress = false;
        } else {
          // let length: number = botMessage['textDisplay'].slice(' ').length;
          botMessage["text"] = botMessage["textDisplay"]
            .split(" ")
            .slice(0, botMessage["index"])
            .join(" ");
          botMessage["index"] += 1;
          document.querySelector(".chat-box").scrollTop =
            document.querySelector(".chat-box").scrollHeight;
        }
      }, 150);
    } else {
      document.querySelector(".chat-box").scrollTop =
        document.querySelector(".chat-box").scrollHeight;
    }

    this.waiting = false;
  }

  copyToClipboard(msg: any, index: number) {
    const textarea = document.createElement("textarea");
    textarea.classList.add('copyattr');
    textarea.value = msg;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    this.messages[index].isCopyDone = !this.messages[index].isCopyDone;
    setTimeout(() => {
      this.messages[index].isCopyDone = false;
    }, 7000);
  }

  downloadText(message: string) {
    const element = document.createElement("a");
    const file = new Blob([message], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "chat_response.txt";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
  options: any[] = [
    { id: "account_info", key: "Demo Account" },
    { id: "minfylabs", key: 'About' },
    {
      id: "managed_services_info",
      key: "Infrastructure Troubleshooting and Support",
    },
    {
      id: "billing_info",
      key: "Billing",
    },
    {
      id: "wafr_info",
      key: "WAFR",
    },
  ];
  selectedOption: string = "Categories";
  isDropdownOpen: boolean = false;

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectOption(option: string): void {
    this.selectedOption = option;
    this.isDropdownOpen = false;
  }
  closeConnection() {
    this.socket.close();
  }
  ngOnDestroy(): void {
    this.currentMessage.unsubscribe();
    this.notifier.enableScroll();
    if(this.intervalId){
      clearInterval(this.intervalId);
    }
    
  }
}
